import { SmoothScrollProvider } from "@/components/primitives/SmoothScrollProvider";
import { GrainCanvas } from "@/components/primitives/GrainCanvas";
import { ViewportFrame } from "@/components/primitives/ViewportFrame";
import { S01_ColdOpen } from "@/components/sections/S01_ColdOpen";
import { S02_Thesis } from "@/components/sections/S02_Thesis";
import { S03_ActOne } from "@/components/sections/S03_ActOne";
import { S04_ActTwo } from "@/components/sections/S04_ActTwo";
import { S05_ActThree } from "@/components/sections/S05_ActThree";
import { S05b_TheFilms } from "@/components/sections/S05b_TheFilms";
import { S06_TheDish } from "@/components/sections/S06_TheDish";
import { S06b_OneLanguage } from "@/components/sections/S06b_OneLanguage";
import { S07_TheLabel } from "@/components/sections/S07_TheLabel";
import { S08_TheCrew } from "@/components/sections/S08_TheCrew";
import { S10_TheCanon } from "@/components/sections/S10_TheCanon";
import { S11_TheCanon } from "@/components/sections/S11_TheCanon";
import { S09_EndCard } from "@/components/sections/S09_EndCard";

export default function App() {
  return (
    <SmoothScrollProvider>
      <GrainCanvas />
      <ViewportFrame />
      <main>
        <S01_ColdOpen />
        <S02_Thesis />
        <S03_ActOne />
        <S04_ActTwo />
        <S05_ActThree />
        <S05b_TheFilms />
        <S06_TheDish />
        <S06b_OneLanguage />
        <S07_TheLabel />
        <S08_TheCrew />
        <S10_TheCanon />
        <S11_TheCanon />
        <S09_EndCard />
      </main>
    </SmoothScrollProvider>
  );
}
